import * as _ from 'lodash';

import ICalibrationUsesType = ZoneIQCalibration.ICalibrationUsesType;
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import ICUTimportValidationResult = ZoneIQCalibration.ICUTimportValidationResult;

export class CalibrationUsesTypeModel implements ICalibrationUsesType {
    Id: number;
    Name: string;

    readonly labels?: ICalibrationUsesLabel[] = [];

    importValidationResult?: ICUTimportValidationResult;

    constructor(data: ICalibrationUsesType) {
        Object.assign(this, _.pick(data, ['Id', 'Name', 'importValidationResult']));
    }

    static factory(data: ICalibrationUsesType): CalibrationUsesTypeModel {
        return new CalibrationUsesTypeModel(data);
    }

    addLabel(labelData: ICalibrationUsesLabel) {
        this.labels.push(labelData);
    }
}
